<div class="checkbox-group">
    <label *ngIf="title" class="title">{{title}}</label>
    <div *ngIf="options && options.length" class="checkboxes" [class.inline]="inline" [class.wrap]="wrap">
        <label class="checkbox-container" *ngFor="let opt of options">
            <input type="checkbox" [id]="opt.id ? opt.id : ''" 
            [name]="name" [value]="opt.value" [checked]="opt.checked || isChecked(opt.value)" [disabled]="opt.disabled || isDisabled(opt.value)" 
            (change)="emitChekedValue()">
            <span class="label">{{opt.label}}</span>
            <span class="checkmark"></span>
        </label>
    </div>
</div>